<div class="tds-row">
    <div class="tds-col-xxlg-2 tds-col-xlg-3 tds-col-lg-3 tds-col-md-4 tds-col-sm-6 tds-col-xs-12 tds-u-pb1">
        <tds-datetime 
            type="date"    
            size="sm" 
            class="tds-u-mb1"
            label="Fromdate"
            [(ngModel)]="fromDate"  
            ngDefaultControl
            value="{{fromDate}}" 
            min="2023-01-01">
        </tds-datetime>     
    </div>
    <div class="tds-col-xxlg-2 tds-col-xlg-3 tds-col-lg-3 tds-col-md-4 tds-col-sm-6 tds-col-xs-12 tds-u-pb1">
        <tds-datetime 
            type="date"    
            size="sm" 
            class="tds-u-mb1"
            label="To date"
            [(ngModel)]="toDate"  
            ngDefaultControl
            value="{{toDate}}" 
            min="2023-01-01">
        </tds-datetime> 
    </div>
    <div class="tds-col-xxlg-2 tds-col-xlg-3 tds-col-lg-3 tds-col-md-4 tds-col-sm-6 tds-col-xs-12 "*ngIf="loggedAccount?.reporting === false">
        <tds-text-field
            type="text" 
            size="sm"
            label="Selected user" 
            class="tds-u-mb1"
            [disabled]="true"
            ngDefaultControl
            [(ngModel)]="selectedEmployee"  
            label-position="outside"></tds-text-field> 
    </div>
    <div class="tds-col-xxlg-2 tds-col-xlg-3 tds-col-lg-3 tds-col-md-4 tds-col-sm-6 tds-col-xs-12">
        <tds-text-field *ngIf="loggedAccount && loggedAccount.reporting === false && loggedAccount.sysAdmin === false"
            type="text" 
            size="sm"
            label="Selected user" 
            class="tds-u-mb1"
            ngDefaultControl
            [(ngModel)]="selectedEmployee"  
            label-position="outside"></tds-text-field> 

        <tds-dropdown *ngIf="loggedAccount && (loggedAccount.reporting === true || loggedAccount.sysAdmin === true)"
            filter 
            label="Employee" ngDefaultControl
            label-position="outside" 
            placeholder="Select employee" 
            size="sm" 
            open-direction="auto"> 
            <tds-dropdown-option (click)="selectEmployee(employee)" 
                *ngFor="let employee of employeeList"
                value="{{employee?.email?.toString() || ''}}">
                {{employee.empName}} - {{employee.email}}
            </tds-dropdown-option> 
        </tds-dropdown>
    </div>        
    <div class="tds-col-xxlg-1 tds-col-xlg-1 tds-col-lg-2 tds-col-md-12 tds-col-sm-1 tds-col-xs-12 tds-u-pb12 tds-u-pt3">
        <tds-button [disabled]="isSubmitDisabled()"  type="button" variant="primary" size="sm" text="Search" (click)="getReportData()"> 
            <tds-icon slot="icon" size="20px" name="search"></tds-icon> 
        </tds-button>             
    </div>
</div>

<app-str-spinner [message]="spinnerMessage"></app-str-spinner>



<div *ngIf="dataSource" class="tds-col-md-12">
    <div *ngIf="dataSource.length == 0" class="tds-col-md-12 tds-u-mb1 tds-u-mt1">
        <div><strong>No data was found for user during the chosen period or query not run.</strong></div>
    </div>

    <div *ngIf="dataSource.length > 0" class="tds-col-md-12 tds-u-mb1 tds-u-mt1">
        <div class="tds-u-pt1">Report Total Hours: <strong>{{reportTotalHours}}</strong></div>
        <div class="tds-u-pt1">Row Count: <strong>{{rowCount}}</strong></div>
        <div class="tds-u-pt1 tds-u-pb1" style="color: darkblue;">Showing data for status: TRANSFERRED</div>
    </div>
    
    <tds-table vertical-dividers="false" 
        compact-design="true" 
        responsive="true" 
        no-min-width >
        <tds-table-header >
            <tds-header-cell cell-key="month" sortable="true" cell-value="Month"></tds-header-cell>
            <tds-header-cell cell-key="weekNo" sortable="true" cell-value="Weeek"></tds-header-cell>
            <tds-header-cell cell-key="day" sortable="true" cell-value="Date"></tds-header-cell>
            <tds-header-cell cell-key="projNo" sortable="true" cell-value="Project No"></tds-header-cell>
            <tds-header-cell cell-key="projName" sortable="true" cell-value="Project Name"></tds-header-cell>
            <tds-header-cell cell-key="taskNo" sortable="true" cell-value="Task No"> </tds-header-cell>
            <tds-header-cell cell-key="taskName" sortable="true" cell-value="Task Name"> </tds-header-cell>
            <tds-header-cell cell-key="expType" sortable="true" cell-value="Exp Type"> </tds-header-cell>
            <tds-header-cell cell-value="Hours" text-Align="right"></tds-header-cell>
        </tds-table-header>

        <tds-table-body >
            <tds-table-body-row *ngFor="let row of dataSource">
                <tds-body-cell>
                    <div class="tds-u-pt0" style="white-space: nowrap;text-align: left;">
                        {{row.month}}
                    </div>
                </tds-body-cell>

                <tds-body-cell>
                    <div class="tds-u-pt0"  style="white-space: nowrap;text-align: left;">
                        {{ row.weekNo }}
                    </div>
                </tds-body-cell>

                <tds-body-cell>
                    <div class="tds-u-pt0" style="white-space: nowrap;text-align: left;">
                        {{ row.day }}
                    </div>
                </tds-body-cell>

                <tds-body-cell>
                    <div class="tds-u-pt0" style="text-align: left;">
                        {{ row.projNo }}
                    </div>
                </tds-body-cell>

                <tds-body-cell>
                    <div class="tds-u-pt0" style="text-align: left;">
                        {{ row.projName }}
                    </div>
                </tds-body-cell>
    
                <tds-body-cell>
                    <div class="tds-u-pt0" style="text-align: left;">
                        {{ row.taskNo }}
                    </div>
                </tds-body-cell>

                <tds-body-cell>
                    <div class="tds-u-pt0" style="text-align: left;">
                        {{ row.taskName }}
                    </div>
                </tds-body-cell>

                <tds-body-cell>
                    <div *ngIf="row.isSubTotalRow" class="subTotal" style="text-align: left;">
                        {{ row.expType }}
                    </div>
                    <div *ngIf="!row.isSubTotalRow" class="tds-u-pt0" style="text-align: left;">
                        {{ row.expType }}
                    </div>
                </tds-body-cell>

                <tds-body-cell>
                    <div *ngIf="row.isSubTotalRow" class="tds-u-pr1 subTotal" style="text-align: rigth;">
                        {{ row.hours.toFixed(1) }}
                    </div>
                    <div *ngIf="!row.isSubTotalRow" class="tds-u-pt0 tds-u-pr1" style="text-align: rigth;">
                        {{ row.hours.toFixed(1) }}
                    </div>
                </tds-body-cell>
            </tds-table-body-row>
        </tds-table-body >
    </tds-table>

</div>
